export enum StatusStep {
  SUBMITTED = 'Submitted',
  APPROVED = 'Approved',
  JOINT_APPLICATION = 'Joint Application',
  ACCEPT_LOAN_CONTRACT = 'Accept Loan Contract',
  INSTALLATION_OF_PURCHASE = 'Installation of Purchase',
  START_REPAYMENTS = 'Start Repayments',
  APPLICATION_UNDER_REVIEW = 'Application Under Review',
}

export enum ApplicationSubmissionStatus {
  JOINT_INCOMPLETE = 'jointIncomplete',
  SUBMITTED = 'submitted',
  APPROVED = 'approved',
  REFERRED = 'referred',
  DECLINED = 'declined',
  WITHDRAWN = 'withdrawn',
  FETCHING = 'fetching',
}

export type StepType = {
  title: string;
  key: string;
  description?: string;
  descriptionSize?: 'small' | 'standard';
  content?: string;
  completed?: string;
};

export type Steps = StepType[];
